import React from 'react';
import { useTranslation } from 'utils/i18n';
import './Status.css';

const Status = () => {
  const { t } = useTranslation();
  
  const title = t('title', 'status') || 'System Status';
  
  return (
    <div className="status-page">
      <div className="status-container">
        <h1>{title}</h1>
        <div className="status-content">
          <p>{t('description', 'status') || 'System status information will be displayed here.'}</p>
          <div className="status-sections">
            <div className="status-section">
              <h2>{t('apiServices.title', 'status') || 'API Services'}</h2>
              <div className="status-indicator online">
                <span className="status-dot"></span>
                <span>{t('apiServices.status', 'status') || 'Online'}</span>
              </div>
            </div>
            <div className="status-section">
              <h2>{t('database.title', 'status') || 'Database'}</h2>
              <div className="status-indicator online">
                <span className="status-dot"></span>
                <span>{t('database.status', 'status') || 'Online'}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Status;


